import { render, staticRenderFns } from "./TrGameStatusV2.vue?vue&type=template&id=819a1f96&"
import script from "./TrGameStatusV2.vue?vue&type=script&lang=js&"
export * from "./TrGameStatusV2.vue?vue&type=script&lang=js&"
import style0 from "./TrGameStatusV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports